const attemptResultsByStore = new WeakMap();

const entitlementSnapshot = (company) => ({
  supports_virtual_card: company && company.get('supports_virtual_card'),
  vc_sub_limits: {
    enabled: company && company.getIn(['vc_sub_limits', 'enabled']),
    limit_amount: company && company.getIn(['vc_sub_limits', 'limit_amount']),
  },
});

const attemptResult = ({ store, sessionContext, attemptId, company }) => {
  if (!attemptId) return null;

  let sessions = attemptResultsByStore.get(store);
  if (!sessions) {
    sessions = new Map();
    attemptResultsByStore.set(store, sessions);
  }
  let attempts = sessions.get(sessionContext);
  if (!attempts) {
    attempts = new Map();
    sessions.set(sessionContext, attempts);
  }
  let result = attempts.get(attemptId);
  if (!result) {
    result = {
      priorCompany: entitlementSnapshot(company),
      captured: false,
    };
    attempts.set(attemptId, result);
  }
  return result;
};

export const getPostApprovalPlaidAttemptResult = ({
  store,
  sessionContext,
  attemptId,
  company,
}) => attemptResult({ store, sessionContext, attemptId, company });

export const capturePostApprovalPlaidEntitlementBaseline = (store) => {
  const state = store.getState();
  const session = state.sessions.get('session');
  const attempt = state.post_approval_plaid.get('attempt');
  const attemptId = attempt.get('attempt_id');

  if (!attempt.isTerminal || !attemptId) return null;

  const publicKey = state.sessions.get('public_key');
  const company = state.entities.getIn(['company', session.get('company_id')]);
  return attemptResult({
    store,
    sessionContext: `${session.get('id') || ''}:${publicKey || ''}`,
    attemptId,
    company,
  });
};
